// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

// Store
const territorializacion = new vapi({
    namespaced : true,        
    state: {
        Aterritorializaciones: []
    }
})
.get({
    action: "get_territorializaciones",
    path:   function () {
        return `${process.env.VUE_APP_REST}/api/territorializacion` ;
    },      
    onSuccess: (state, payload) => {        
        state.Aterritorializaciones = payload.data;
    }
}).getStore();

territorializacion.getters = {  
    gterritorializaciones : state =>  {
        return state.Aterritorializaciones;
    }
}
export default territorializacion;
